import { render, staticRenderFns } from "./LoginZalo.vue?vue&type=template&id=7f932965"
import script from "./LoginZalo.vue?vue&type=script&lang=js"
export * from "./LoginZalo.vue?vue&type=script&lang=js"
import style0 from "./LoginZalo.vue?vue&type=style&index=0&id=7f932965&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports